export default {
    statusBaseData: 'Daten',
    statusNotifications: 'Statusbenachrichtigungen',

    statusTransitions: 'Übergänge',
    statusBehavior: 'Verhalten',
    statusActivities: 'Historie'
}